exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-download img {\n  height: 5vh;\n  margin-bottom: 1em;\n}\n.footer-info img {\n  height: 4vh;\n  margin-bottom: 0.5em;\n}\n.footer {\n  text-align: center;\n  background-color: black;\n  color: white;\n  padding-top: 3em;\n  padding-bottom: 2em;\n}\nhr {\n  border-color: rgba(206, 197, 197, 0.699);\n}\n.small-text {\n  font-size: 0.8em;\n}\n.small-text span{\n  margin-right: 1em;\n}\n.footer-info {\n  margin-bottom: 2em;\n}\n.col-md-1 {\n  padding-left: 0;\n  padding-right: 0;\n  width: 2em;\n}\n.row {\n  margin-right: 0;\n}\n.icons-row {\n  text-align: center;\n  padding-bottom: 1em;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/skye/Projects/Epicodus Projects/JavaScript/mock-mint/src/app/footer/footer.component.css
// module id = ../../../../../src/app/footer/footer.component.css
// module chunks = main